export const APP_RESUME_REQUEST_EVENT = "seexr:resume-request";
export const APP_RESUME_EVENT = "seexr:resume";
export const APP_SUSPEND_EVENT = "seexr:suspend";

export type AppResumeReason =
  | "focus"
  | "online"
  | "pageshow"
  | "popstate"
  | "resume"
  | "visibilitychange";

export type AppSuspendReason = "freeze" | "pagehide";

export type AppResumeDetail = {
  at: number;
  reason: AppResumeReason;
  persisted?: boolean;
};

export type AppSuspendDetail = {
  at: number;
  reason: AppSuspendReason;
  persisted?: boolean;
};

export function emitAppResumeRequest(detail: AppResumeDetail) {
  window.dispatchEvent(
    new CustomEvent<AppResumeDetail>(APP_RESUME_REQUEST_EVENT, { detail }),
  );
}

/**
 * Session reconciliation이 끝난 뒤에만 전달하는 application-level resume.
 * Chat/RA stream과 Sidebar 등 기존 소비자는 이 이벤트를 그대로 사용한다.
 */
export function emitAppResume(detail: AppResumeDetail) {
  window.dispatchEvent(new CustomEvent<AppResumeDetail>(APP_RESUME_EVENT, { detail }));
}

export function emitAppSuspend(detail: AppSuspendDetail) {
  window.dispatchEvent(new CustomEvent<AppSuspendDetail>(APP_SUSPEND_EVENT, { detail }));
}
